import { useCallback, useReducer } from "react";
function useRouter(props) {
  const [router, dispatch] = useReducer(reducer, props, createInitialState);
  const navigate = useCallback((to) => {
    dispatch(goTo(to));
  }, []);
  const goToPalette = useCallback(() => {
    dispatch(goTo({ id: "palette" }));
  }, []);
  const goToAddColorToPalette = useCallback((group) => {
    dispatch(goTo({ group, id: "add-color-to-palette" }));
  }, []);
  const goToCustom = useCallback(() => {
    dispatch(goTo({ id: "custom" }));
  }, []);
  return {
    goToAddColorToPalette,
    goToCustom,
    goToPalette,
    navigate,
    router
  };
}
function reducer(state, action) {
  const currentRoute = state.route.id;
  switch (action.type) {
    case "goTo": {
      switch (action.route.id) {
        case "add-color-to-palette": {
          if (currentRoute !== "palette") {
            console.warn("only palette route can navigate to this route");
          }
          return { ...state, route: action.route };
        }
        default:
          return { ...state, route: action.route };
      }
    }
    default:
      return state;
  }
}
function createInitialState(props) {
  const { palette, picker } = props;
  const invalidState = !palette && !picker;
  if (invalidState) {
    console.error("At least one between palette and picker should be provided");
  }
  const showPicker = picker && !palette;
  if (showPicker) return { route: { id: "custom" } };
  return { route: { id: "palette" } };
}
function goTo(route) {
  return { route, type: "goTo" };
}
export {
  useRouter
};
//# sourceMappingURL=useRouter.js.map
